export default __webpack_public_path__ + "static/media/three.f00f8219.jpeg";